import React from 'react';

import {
  required,
  minValue,
  NumberInput,
} from 'react-admin';

import { Grid } from '@mui/material';

import SelectInput from '../../../layout/inputFields/SelectInput';

import Label from '../../../../customFields/Label';

const RuleScore = () => (
  <Grid container spacing={3}>
    <Grid size={12}>
      <Label
        variant="label"
        title="Rule decreasing timeline"
        info="The risk decreasing timeline is adjusting the risk of the entity based on a algorithm over the inputted time"
      />
    </Grid>
    <Grid
      size={{
        xs: 6,
        md: 6,
      }}
    >
      <NumberInput
        source="riskTimeline.amount"
        fullWidth
        label="Number"
        validate={[required(), minValue(1)]}
      />
    </Grid>
    <Grid
      size={{
        xs: 6,
        md: 6,
      }}
    >
      <SelectInput
        source="riskTimeline.period"
        choices={[{ id: 'months', name: 'months' },
          { id: 'days', name: 'days' },
          { id: 'years', name: 'years' }]}
        fullWidth
        label="Unit"
        validate={required()}
      />
    </Grid>
  </Grid>
);

export default RuleScore;
